export default "__VITE_ASSET__B$Dj_$un__"